import type { ExportRequest } from '../types/export';

export async function downloadWorkspaceExport(workspaceId: string, request: ExportRequest, signal?: AbortSignal) {
  const response = await fetch(`/api/v1/workspaces/${workspaceId}/exports`, {
    method: 'POST',
    credentials: 'same-origin',
    cache: 'no-store',
    signal,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request)
  });
  if (!response.ok) {
    const problem = (await response.json().catch(() => null)) as { title?: string; message?: string } | null;
    throw new Error(problem?.title ?? problem?.message ?? 'Das PDF konnte nicht erstellt werden.');
  }
  const blob = await response.blob();
  if (signal?.aborted) return;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const title = [...(request.title?.trim() || 'chronis-export')]
    .map((char) => (char.charCodeAt(0) < 32 ? '_' : char))
    .join('');
  link.download = `${title.replace(/[<>:"/\\|?*]/g, '_')}.pdf`;
  link.click();
  // Allow the browser to begin reading before releasing the object URL.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
